// import node module libraries
import { Fragment, useEffect, useState } from "react";
import { Menu } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { Nav, Navbar, Form } from "react-bootstrap";

// import sub components
import QuickMenu from "layouts/QuickMenu";
import PrimaryMenu from "./PrimaryMenu";
import companyLogo from "../../assets/images/company-logo.png";
import { subDomainLogoMapping } from "constants/Constants";

const HeaderDefault = (props) => {
  const [activeMenu, setActiveMenu] = useState(-1);
  const [logo, setLogo] = useState(null); // Initialize as null
  const [isLoading, setIsLoading] = useState(true); // Track image loading
  const navigate = useNavigate();

  const getSubdomain = () => {
    const host = window.location.hostname;
    const parts = host.split(".");
    return parts.length > 1 ? parts[0] : null;
    //return "default";
  };

  useEffect(() => {
    const subDomain = getSubdomain();
    if (subDomain && subDomain !== "default") { // Treat "default" like null
      const result = subDomainLogoMapping.find((sD) => sD?.name === subDomain);
      setLogo(result?.logo || null);
    } else {
      setLogo(null); // Set null for "default" or no subdomain
    }
    setIsLoading(false); // Mark loading as complete
  }, []);

  // Handle image load success
  const handleImageLoad = () => {
    setIsLoading(false);
  };

  // Handle image load error (e.g., broken URL)
  const handleImageError = () => {
    setLogo(null);
    setIsLoading(false);
  };

  return (
    <Fragment>
      <Navbar expanded="lg" className="navbar-default" fixed="top">
        <div className="d-flex justify-content-between w-100">
          <div
            className="d-flex align-items-center"
            onClick={(e) => {
              e.preventDefault();
              setActiveMenu(-1);
              if (window.location.pathname === "/dashboard/overview" || window.location.pathname === "/") {
                navigate("/dashboard/overview", { state: { refreshKey: Date.now() }, replace: true });
              } else {
                navigate("/dashboard/overview");
              }
            }}
          >
            <Link id="nav-toggle" to="#">
              <div
                className="logo-container"
                style={{
                  width: "200px",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {isLoading || logo === null ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#fff", // Light gray placeholder
                    }}
                  />
                ) : (
                  <img
                    src={logo || companyLogo}
                    alt="logo"
                    className="logo-image"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                    onLoad={handleImageLoad}
                    onError={handleImageError}
                  />
                )}
              </div>
            </Link>
          </div>
          <div className="d-flex mx-5 align-items-center">
            <PrimaryMenu
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
            />
          </div>
          <Nav className="navbar-nav navbar-right-wrap ms-auto d-flex align-items-center nav-top-wrap">
            <QuickMenu />
          </Nav>
        </div>
      </Navbar>
    </Fragment>
  );
};

export default HeaderDefault;

// // import node module libraries
// import { Fragment, useEffect, useState } from "react";
// import { Menu } from "react-feather";
// import { Link, useNavigate } from "react-router-dom";
// import { Nav, Navbar, Form } from "react-bootstrap";

// // import sub components
// import QuickMenu from "layouts/QuickMenu";
// import PrimaryMenu from "./PrimaryMenu";
// import companyLogo from "../../assets/images/company-logo.png";
// import { subDomainLogoMapping } from "constants/Constants";

// const HeaderDefault = (props) => {
//   const [activeMenu, setActiveMenu] = useState(-1);
//   const [logo, setLogo] = useState("");
//   const navigate = useNavigate();
//   const getSubdomain = () => {
//     const host = window.location.hostname;
//     const parts = host.split(".");
//     return parts.length > 1 ? parts[0] : null;
//   };
//   useEffect(() => {
//     const subDomain = getSubdomain();
//     const result = subDomainLogoMapping.filter((sD) => {
//       return sD?.name === subDomain;
//     });
//     setLogo(result?.[0]?.logo);
//   }, []);

//   return (
//     <Fragment>
//       <Navbar expanded="lg" className="navbar-default" fixed="top">
//         <div className="d-flex justify-content-between w-100">
//           <div
//             className="d-flex align-items-center"
//             onClick={() => {
//               setActiveMenu(-1);
//               navigate("/dashboard/overview");
//             }}
//           >
//             <Link
//               id="nav-toggle"
//               to="#"
//               // onClick={() => props.data.SidebarToggleMenu(!props.data.showMenu)}
//             >
//               {/* <img src={logo || companyLogo} width={100} height={100} /> */}
//               <div
//                 className="logo-container"
//                 style={{
//                   width: "200px",
//                   height: "50px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   overflow: " hidden",
//                 }}
//               >
//                 <img
//                   src={logo || companyLogo}
//                   alt="logo"
//                   className="logo-image"
//                   style={{
//                     maxWidth: "100%",
//                     maxHeight: "100%",
//                     objectFit: "contain",
//                   }}
//                 />
//               </div>
//               {/* Navigation menu with static links */}
//               {/* <Menu size="18px" /> */}
//             </Link>
//             {/* <div className="ms-lg-3 d-none d-md-none d-lg-block">
// 							<Form className="d-flex align-items-center">
// 								<span className="position-absolute ps-3 search-icon">
// 									<i className="fe fe-search"></i>
// 								</span>
// 								<Form.Control type="search" className="form-control ps-6" placeholder="Search Entire Dashboard" />
// 							</Form>
// 						</div> */}
//           </div>
//           <div className="d-flex mx-5 align-items-center">
//             {/* Navigation menu with static links */}
//             {/* {}
//             <Link to="/courses" className="text-dark">
//               Courses
//             </Link>
//             <Link to="/user-groups" className="mx-3 text-dark">
//               Training Programs
//             </Link>
//             <Link to="/configOrg" className="mx-3 text-dark">
//             Organization
//             </Link> */}
//             <PrimaryMenu
//               activeMenu={activeMenu}
//               setActiveMenu={setActiveMenu}
//             />
//           </div>
//           <Nav className="navbar-nav navbar-right-wrap ms-auto d-flex align-items-center nav-top-wrap">
//             <QuickMenu />
//           </Nav>
//         </div>
//       </Navbar>
//     </Fragment>
//   );
// };

// export default HeaderDefault;
